import { render, staticRenderFns } from "./ChatRoomMenu.vue?vue&type=template&id=c9bd57a0&scoped=true&lang=html&"
import script from "./ChatRoomMenu.vue?vue&type=script&lang=js&"
export * from "./ChatRoomMenu.vue?vue&type=script&lang=js&"
import style0 from "./ChatRoomMenu.vue?vue&type=style&index=0&id=c9bd57a0&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9bd57a0",
  null
  
)

export default component.exports